import { Layout, Space, Tabs, Typography } from "antd";
import React, { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";

import routes from "../../../engine/routes";
import {
  clearBilling,
  getCountType,
  getUniqueInstitutionsBills,
  getUniqueLanguagesInBills,
} from "../Slices/Billing.slice";
import { BillsByType } from "./BillsByType";
import { ActionRoleSpecific } from "../../../engine/AuthRoute";
import { roles } from "../../../utils/constants";
import LogHistory from "../../../shared/components/LogHistory";

const { Content, Sider, Header, Footer } = Layout;

export function BillingList(props) {
  const [activeTab, setActiveTab] = useState("unique");
  const [year, setYear] = useState(new Date().getFullYear());
  const dispatch = useDispatch();

  const { countType } = useSelector(state => state.billing);

  const handleTabChange = key => {
    setActiveTab(key);
  };

  const getCounts = () => {
    // dispatch(getCountType(year));
  };

  useEffect(() => {
    // getCounts();
  }, [year]);

  useEffect(() => {
    dispatch(getUniqueInstitutionsBills());
    dispatch(getUniqueLanguagesInBills());
    // getCounts();
    return () => {
      dispatch(clearBilling());
    };
  }, []);

  return (
    <Content>
      <ActionRoleSpecific only={[roles.admin, roles.permanance]}>
        <LogHistory
          linkType={"detail"}
          route={"/api/bills/xml"}
          label={"Exportation XML la plus récente"}
        />
        <LogHistory
          linkType={"detail"}
          route={"/api/bills/xlxs"}
          label={"Exportation XLXS la plus récente"}
        />
      </ActionRoleSpecific>
      <Space
        style={{
          flexDirection: "row",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography.Title level={2} className={""}>
          {routes.billing().list.title}
        </Typography.Title>

        <div id={"actionsBills"}></div>
      </Space>

      <div id={"formBills"}></div>
      <Tabs
        defaultActiveKey="unique"
        onChange={handleTabChange}
        type="card"
        size="large"
        className="prestations-tabs"
      >
        <Tabs.TabPane
          tab={`Factures uniques ${countType.unique}`}
          key={"unique"}
        >
          {activeTab === "unique" ? (
            <BillsByType
              type="unique"
              key={"unique"}
              name={"unique"}
              isExternal={false}
              setYear={setYear}
            />
          ) : null}
        </Tabs.TabPane>
        <Tabs.TabPane
          tab={`Factures groupées ${countType.multiple}`}
          key={"multiple"}
        >
          {activeTab === "multiple" ? (
            <BillsByType
              type="multiple"
              key={"multiple"}
              name={"multiple"}
              isExternal={false}
              setYear={setYear}
            />
          ) : null}
        </Tabs.TabPane>
        <Tabs.TabPane
          tab={`Factures externes ${countType.external}`}
          key={"external"}
        >
          {activeTab === "external" ? (
            <BillsByType
              type="unique"
              key={"external"}
              name={"external"}
              isExternal={true}
              setYear={setYear}
            />
          ) : null}
        </Tabs.TabPane>
      </Tabs>
    </Content>
  );
}
